export default {
  title: {
    en: 'Review {title}',
  },
  description: {
    en: 'Please edit your review',
  },

  reviewPlaceholder: {
    en: 'Review',
  },

  edit: {
    en: 'Edit review',
  },
  save: {
    en: 'Save review',
  },
}
